export function transformPayload(invoiceLimitPayload) {
  // Parse the embedded JSON payload
  const embeddedPayload = JSON.parse(invoiceLimitPayload.payload);
  
  // Calculate total amount from bills
  const totalAmount = embeddedPayload.Bills.reduce((sum, bill) => sum + bill.Amount, 0);
  
  // Transform to format B
  const transformedPayload = {
    // Map from root level fields
    id: invoiceLimitPayload.id,
    invoiceNumber: invoiceLimitPayload.invoiceNumber?.trim(), // Remove trailing spaces
    
    // Map from embedded payload
    agencyId: embeddedPayload.AgencyId,
    agencyName: null, // Not available in payload A
    agencyAddress: null, // Not available in payload A
    
    // Customer information from embedded payload
    customer: embeddedPayload.Name,
    serviceProviderName: embeddedPayload.Name,
    customerAddress: embeddedPayload.Address,
    customerPhone: embeddedPayload.Phone,
    customerEmail: embeddedPayload.Emails,
    customerAIN: embeddedPayload.CustomerAIN,
    
    // Revenue information
    revenue: null, // Not available in payload A, would need lookup by RevenueId
    revenueGroupName: "",
    customerParentAIN: null,
    revenueCode: null, // Not available in payload A
    revenueId: embeddedPayload.RevenueId,
    revenueGroupId: embeddedPayload.RevenueGroupId,
    
    // Date and amount information
    invoiceDate: embeddedPayload.InvoiceDate,
    amount: totalAmount,
    amountPaid: 0, // Default value, not available in payload A
    
    // Bills array - transform structure
    bills: embeddedPayload.Bills.map(bill => ({
      id: bill.Id,
      amount: bill.Amount,
      status: 3, // Default status, not available in payload A
      quantity: bill.Quantity,
      description: bill.Description,
      rate: bill.Rate,
      invoiceID: invoiceLimitPayload.id // Use the main invoice ID
    })),
    
    // Currency and location information
    currencyId: embeddedPayload.CurrencyId,
    currencyUTF32Code: null, // Not available in payload A
    decimalPrecisions: 2, // Default value
    locationId: embeddedPayload.LocationId,
    location: null, // Not available in payload A, would need lookup by LocationId
    
    // Creator information from root level
    creatorId: invoiceLimitPayload.initiatorId,
    creatorEmail: null, // Not available in payload A
    createdByName: invoiceLimitPayload.initiatorName,
    
    // Additional fields
    deleted: false, // Default value
    remitaRetrievalReference: embeddedPayload.RRR || "",
    editComment: invoiceLimitPayload.initiatorComment,
    postTransaction: false, // Default value
    isEdited: false, // Default value
    
    // Computed fields (would need currency symbol lookup)
    amountString: `₦ ${totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    currencyCode: "₦" // Default Nigerian Naira symbol
  };
  
  return transformedPayload;
}
